<div class="row" *ngIf="!value || view === 'update'">

  <div class="col-lg-12">
    <div class="">
      <div class="">
        <p>Select which charity this campaign is for*</p>
        <a class="btn btn-sm btn-outline-theme" (click)="selectDialog()">
          <i class="fi fi-br-search"></i> Select Charity
        </a>
      </div>
    </div>
  </div>

</div>

<div *ngIf="value && view === 'selected'">

  <div class="">

    <div class="">

      <div class="d-flex align-items-center">
        <div class="symbol symbol-45px me-5" *ngIf="value.brand_logo">
          <img [src]="value.brand_logo" alt=""/>
        </div>
        <div class="symbol symbol-45px me-5" *ngIf="!value.brand_logo">
          <img [src]="'assets/media/place.svg'" alt=""/>
        </div>
        <div class="">
          <p class="fs-6">
            Selected Charity: {{value.public_name | titlecase}}
          </p>
          <button type="button" class="btn btn-outline-theme btn-xs" (click)="selectDialog()">Change Charity</button>
        </div>
      </div>

    </div>

  </div>
</div>
